export const ProductTypes = {
  SIMPLE: 'simple',
  ONE_SIZE: 'One Size',
  CONFIGURABLE: 'configurable',
};

export const isOneSizeProduct = ({
  productType,
  sizeLength,
}: {
  productType: string;
  sizeLength: number;
}): boolean => {
  return productType.toLowerCase() === ProductTypes.SIMPLE && sizeLength === 0;
};
